import { CmITableConfig } from './table-config.interface';
import { CmTableRow } from './table-row.type';

/**
 * Config object for setting up a cm table.
 * @class CmTableConfig
 * @param {CmITableConfig} config - The config object for a CmTableConfig object.
 * @property {boolean} [selectable = false] - Makes the table selectable
 * @property {boolean} [disableMultiselect = false] - Makes a selectable table single-select only
 * @property {boolean} [disableSearch = false] - Removes the search box above a table
 * @property {boolean} [disableExport = false] - Removes the export/download button above the table
 * @property {boolean} [disableSelectFilter = false ] - Removes the selection status filter on a select table.
 * @property {boolean} [clearSelectionOnUpdate = true ] - Clears out the current selection status when the row observable updates.
 * @property {string} [rowKey = 'id'] - The row property with a uniqe value to use as an ID for managing selections.
 * @property {string} [exportFilename = 'CertMetrics_Export'] - The default filename for the export download
 * @property {number[]} [pageOptions = [25, 50, 100]] - The default paging options used for pagination.
 * @property {(row: CmTableRow) => boolean} [isSelected] - A method used to determine the default selected rows
 */
export class CmTableConfig {
	selectable: boolean = false;
	disableMultiselect: boolean = false;
	disableSearch: boolean = false;
	disableExport: boolean = false;
	disableMeta: boolean = false;
	disableSelectFilter: boolean = false;
	clearSelectionOnUpdate: boolean = true;
	rowKey: string = 'id';
	exportFilename: string = 'CertMetrics_Export';
	pageOptions: number[] = [25, 50, 100];
	pageSize: number = 25;

	/**
	 * @method
	 * @param {CmTableRow} row - The table row data.
	 * @return {boolean} - Selects the row by default.
	 */
	isSelected?: (row: CmTableRow) => boolean;

	constructor(config?: CmITableConfig) {
		if (config) {
			if (Object.hasOwnProperty.call(config, 'selectable')) this.selectable = config.selectable;
			if (Object.hasOwnProperty.call(config, 'disableMultiselect'))
				this.disableMultiselect = config.disableMultiselect;
			if (Object.hasOwnProperty.call(config, 'disableSearch')) this.disableSearch = config.disableSearch;
			if (Object.hasOwnProperty.call(config, 'disableExport')) this.disableExport = config.disableExport;
			if (Object.hasOwnProperty.call(config, 'disableMeta')) this.disableMeta = config.disableMeta;
			if (Object.hasOwnProperty.call(config, 'disableSelectFilter'))
				this.disableSelectFilter = config.disableSelectFilter;
			if (Object.hasOwnProperty.call(config, 'clearSelectionOnUpdate'))
				this.clearSelectionOnUpdate = config.clearSelectionOnUpdate;
			if (Object.hasOwnProperty.call(config, 'exportFilename')) this.exportFilename = config.exportFilename;
			if (Object.hasOwnProperty.call(config, 'rowKey')) this.rowKey = config.rowKey;
			if (Object.hasOwnProperty.call(config, 'pageOptions')) this.pageOptions = config.pageOptions;
			if (Object.hasOwnProperty.call(config, 'pageSize')) this.pageSize = config.pageSize;
			if (Object.hasOwnProperty.call(config, 'isSelected')) this.isSelected = config.isSelected;
		}
	}
}
